/** Rojo = nuevas · Naranja = incidencias abiertas · Verde = leídas · Lila = sin notas */
export const getNoteBadgeState = ({
  noteCount = 0,
  unreadCount = 0,
  openIssueCount = 0,
} = {}) => {
  const total = Number(noteCount) || 0;
  const unread = Number(unreadCount) || 0;
  const openIssues = Number(openIssueCount) || 0;

  if (total === 0) {
    return { variant: "empty", noteCount: total, unreadCount: unread, openIssueCount: openIssues };
  }
  if (unread > 0) {
    return { variant: "unread", noteCount: total, unreadCount: unread, openIssueCount: openIssues };
  }
  if (openIssues > 0) {
    return { variant: "issue", noteCount: total, unreadCount: unread, openIssueCount: openIssues };
  }
  return { variant: "normal", noteCount: total, unreadCount: unread, openIssueCount: openIssues };
};
